/**
 * Created by piotr.pozniak@thebeaverhead.com on 29/12/2025.
 */
import axios from "axios";
import AxiosConfig from "../AxiosConfig";

/**
 *
 */
export function fetchDashboardStats() {
  return function (dispatch) {
    dispatch({ type: "DASHBOARD_STATS_FETCH" });
    const url =
      AxiosConfig.getEndpointAddress() + `/api/reports/dashboard.json`;

    axios
      .get(url, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "DASHBOARD_STATS_FETCH_FULFILLED",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "DASHBOARD_STATS_FETCH_REJECTED",
          payload: error,
        });
      });
  };
}

/**
 *
 */
export function fetchEventsStats({
  from,
  to,
  sortField = "impressions",
  sortDirection = "desc",
  limit = 10,
  page = 1,
  status,
}) {
  return function (dispatch) {
    dispatch({ type: "EVENTS_STATS_FETCH" });

    const params = {
      from,
      to,
      sort_field: sortField,
      sort_direction: sortDirection,
      limit,
      page,
    };
    if (status) {
      params.status = status;
    }

    const url = `${AxiosConfig.getEndpointAddress()}/api/reports/events_stats.json?${AxiosConfig.objectToURLQuery(
      params
    )}`;

    axios
      .get(url, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "EVENTS_STATS_FETCH_FULFILLED",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "EVENTS_STATS_FETCH_REJECTED",
          payload: error,
        });
      });
  };
}
/**
 *
 */
export function fetchEventsTimeSeriesStats(from, to) {
  return function (dispatch) {
    dispatch({ type: "EVENTS_TIME_SERIES_FETCH" });
    const url = `${AxiosConfig.getEndpointAddress()}/api/reports/events_time_series.json?${AxiosConfig.objectToURLQuery(
      { from, to }
    )}`;

    axios
      .get(url, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "EVENTS_TIME_SERIES_FETCH_FULFILLED",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({ type: "EVENTS_TIME_SERIES_FETCH_REJECTED", payload: error });
      });
  };
}

export function fetchEventSeriesStats(from, to, eventUuid) {
  return function (dispatch) {
    dispatch({ type: "EVENT_SERIES_FETCH" });
    const url = `${AxiosConfig.getEndpointAddress()}/api/reports/events_time_series.json?${AxiosConfig.objectToURLQuery(
      { from, to, event_uuid: eventUuid }
    )}`;

    axios
      .get(url, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "EVENT_SERIES_FETCH_FULFILLED",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({ type: "EVENT_SERIES_FETCH_REJECTED", payload: error });
      });
  };
}

export function fetchPlanUsageStats() {
  return function (dispatch) {
    dispatch({ type: "PLAN_USAGE_STATS_FETCH" });
    const url =
      AxiosConfig.getEndpointAddress() + `/api/reports/plan-usage.json`;

    axios
      .get(url, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "PLAN_USAGE_STATS_FETCH_FULFILLED",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "PLAN_USAGE_STATS_FETCH_REJECTED",
          payload: error,
        });
      });
  };
}
